import React, { forwardRef } from "react";

const Input = ({ regexpFilter, isDisabled = false, ...props }, ref) => {
  const { onChange, onBlur } = props;

  const regexBeforeOnChange = (event) => {
    if (!regexpFilter) {
      if (onChange) onChange(event);
      return;
    }

    const oldValue = event?.target?.value;
    const newValue = event?.target?.value?.replaceAll(regexpFilter, "");

    if (newValue !== oldValue) {
      // eslint-disable-next-line no-param-reassign
      event.target.value = newValue;
    }
    if (onChange) onChange(event);
  };

  const trimBeforeOnBlur = (event) => {
    const oldValue = event?.target?.value;
    const newValue = event?.target?.value?.trim();

    if (newValue !== oldValue) {
      // eslint-disable-next-line no-param-reassign
      event.target.value = newValue;
      if (onChange) regexBeforeOnChange(event);
    }
    if (onBlur) onBlur(event);
  };

  return (
    <input
      type="text"
      ref={ref}
      {...props}
      onChange={regexBeforeOnChange}
      onBlur={trimBeforeOnBlur}
      disabled={isDisabled}
    />
  );
};

export const InputTrim = forwardRef(Input);
